import React, { Component, Fragment } from "react";
import Alert from "react-s-alert";
import {Input, Button, Alert as Alert2} from "reactstrap";
import { api, constant } from "../helpers";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './Site.css';
import {ProductPartTypeahead } from "../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class CycleCountRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      item: this.props.item,
      options: [],
      inputValue: ''
    };
    this.onDismiss = this.onDismiss.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onTypeAheadChange = this.onTypeAheadChange.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  componentDidMount() {
  }
  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null
    });
  }

  onInputChange(input, fieldName) {
    this.setState({
      item: { ...this.state.item, [fieldName]: input.target.value }
    });
  }

  onSelectChange(selection, fieldName) {
    this.setState({
      item: {
        ...this.state.item, [fieldName]: selection.value
          ? selection : selection.target.value
      }
    })
  }

  onDateChange(selectedDate, fieldName) {
    this.setState({
      item: { ...this.state.item, [fieldName]: selectedDate }
    });
  }

  onTypeAheadChange(selection) {
    this.setState({
      item: {
        ...this.state.item,
        description: selection.description,
        unitOfMeasurement: selection.unitOfMeasurement,
        isProductContent: selection.isProductContent,
        productSku: selection.isProductContent ? selection.label : null,
        partNumber: selection.isProductContent ? null : selection.label,
        content: selection
      }
    })
  }
  isFormValid() {
    let warnings = [];
    if (!this.state.item.content) {
      warnings.push("Please enter a product or part");
    }
    this.setState({
      message: warnings.length ? warnings.join(", ") : null,
      messageColor: "danger",
      isMessageVisible: true
    });
    return warnings.length === 0;
  }

  onSave() {
    if (!this.isFormValid()) return;
    let item = Object.assign({}, this.state.item);
    //console.log(this.props.wareHouseArea)
    let payload = {
      Bay: parseInt(item.bay, 10),
      Bin: parseInt(item.bin, 10),
      WarehouseAreaId: parseInt(this.props.wareHouseArea.value, 10),
      WarehouseBinId: item.WarehouseBinId !== null ? parseInt(item.WarehouseBinId, 10) : null,
      PartId: item.isProductContent ? null : parseInt(item.content.value, 10),
      ProductId: item.isProductContent ? parseInt(item.content.value, 10) : null,
      ProductQuantity: item.isProductContent ? parseInt(item.productQuantity, 10) : null,
      PartQuantity: item.isProductContent ? null : parseFloat(item.partQuantity),
      TransferDate: item.transferDate,
      ExpirationDate: item.expirationDate,
      LotNumber: item.lotNumber,
      PoNumber: item.poNumber
    }
    api.post("Warehouse/SaveInventoryCycleCount", payload)
      .then(response => {
        if (response.data) {
          Alert.success("Count was saved");
          this.setState({
            item: {
              ...this.state.item,
              id: response.data.id
            }
          }, () => this.props.exitEditMode())
        }
      }).catch(error =>
        Alert.error(`There was an error saving count`)
      );
  }

  onAddNewLine(index) {
    this.props.addNewRow(index);
  }

  render() {
    const { item } = this.state;
    return (
      <Fragment>
        {this.state.message ? (
        <Alert2
          color={this.state.messageColor}
          toggle={() => this.onDismiss()}
        >
          {this.state.message}
        </Alert2>
      ) : null}

        <td>{item.bay}</td>
        <td>{item.bin}</td>
        <td style={{ width: "244px" }}>
          {item.editing ? (
            <ProductPartTypeahead
              url={constant.url.ProductPartTypeahead}
              placeholder={"Product Sku or Part #"}
              onChange={this.onTypeAheadChange}
              selectedOption={item.content}
              disabled={!item.editing}
            />           
          ) : (
            <span>{item.content.label}</span>
          )}
        </td>
        <td>{item.description}
        </td>
        <td>
          <Input type="text" name="lotNumber" value={item.lotNumber} disabled={!item.editing} onChange={(e) => this.onInputChange(e, "lotNumber")} />
        </td>
        <td>{item.unitOfMeasurement}</td>
        <td>
          {item.isProductContent
            ? <Input type="number" name="productQuantity" value={item.productQuantity} onChange={(e) => this.onInputChange(e, "productQuantity")}
              disabled={!item.editing || (!item.productSku && !item.partNumber)} />
            : <Input step="0.01" name="partQuantity" type="number" value={item.partQuantity} onChange={(e) => this.onInputChange(e, "partQuantity")}
              disabled={!item.editing || (!item.productSku && !item.partNumber)} />
          }
        </td>
        <td>
          <DatePicker
            selected={item.expirationDate}
            className="form-control pageTitleItem float-right mr-2"
            placeholderText="Select a date"
            onChange={(e) => this.onDateChange(e, "expirationDate")}
            disabled={!item.editing}
          />
        </td>
        <td><Input type="text" name="poNumber" value={item.poNumber} disabled={!item.editing} onChange={(e) => this.onInputChange(e, "poNumber")} /></td>
        <td>
          <DatePicker
            selected={item.transferDate}
            className="form-control pageTitleItem float-right mr-2"
            placeholderText="Select a date"
            onChange={(e) => this.onDateChange(e, "transferDate")}
            onBlur={this.onSave}
            disabled={!item.editing}
          />
        </td>
        <td>
          <Button className="cbdmdPrimary" onClick={() => this.onAddNewLine(this.props.index)} disabled={!item.editing}><FontAwesomeIcon icon="retweet" /></Button>
        </td>
      </Fragment>
    );
  }
  }


// WEBPACK FOOTER //
// ./src/components/CycleCountRow.js